export default __webpack_public_path__ + "static/media/email.86506964.svg";